export const ModalItems = {
  title: 'Ver Artigos do Pedido BO {orderID}',
  tableColumn1: 'Referência LM',
  tableColumn2: 'EAN',
  tableColumn3: 'Designação',
  tableColumn4: 'Qtd Pedida',
  tableColumn5: 'Estado',
  Available: 'Disponivel',
  'Partially Available': 'Parcial',
  'DC Allocated': 'DC Alocada',
  'Released': 'Libertada',
  'DO Partially Created': 'DO Parcialmente Criada',
  'DO Created': 'DO Criado',
  'Partially Completed': 'Parcialmente completo',
  'Completed': 'Completo',
  'Partially DC Allocated': 'DC Parcialmente alocado',
  'Sourced': 'Origem',
  'Partially Sourced': 'Fornecido Parcialmente',
  'Sourcing Failed': 'Falha no fornecimento',
  'Scheduling Failed': 'Falha no agendamento',
  'Allocated': 'Alocada',
  'Partially Allocated': 'Parcialmente alocada',
  'Allocation Failed': 'Falha na alocação',
  'Created': 'Criado',
  'Canceled': 'Anulado',
  'Partially Released': 'Libertado parcialmente',
  'Invalid': 'Invalido',
  'Partially Shipped': 'Enviado parcialmente',
  'Shipped': 'Enviado',
  'Delivered': 'Entregue',
  'Picked Up': 'Levantado',
  'Partially Picked Up': 'Parcialmente levantado',
  'Not Validated': 'Não validado',
  'Validated': 'Validado',
  'Ordered': 'Encomendado',
  'Put In Order': 'Coloque Em Ordem',
  'Immediate': 'Entrega Imediata',
  'Payed': 'Pago',
  'Withdrawed': 'Retirado',
  'Solded': 'Vendido'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/ModalItems.js